// frontend/src/components/chrome/Chamber.tsx
// The layout shell for the live argument, and the reason it exists is that the
// argument should not share one.
//
// /play/:gameId used to render inside <Chrome>, so the wordmark, five nav
// links, XP bar, streak, rank, gear menu and theme toggle sat above the marble
// chamber for the whole of a timed spoken performance, eight controls whose
// only purpose during an argument is to leave it. Considerable effort had gone
// into making that navigation SAFE to click mid-argument (every link is a
// GuardedLink that raises the leave modal). The better answer is that it should
// not be there: from "Begin Argument" to "Continue to Score", the browser
// chrome is the only chrome and the room is the whole screen.
//
// What survives: the leave guard (the browser back button still routes through
// the same modal), toasts, and the "Leave the lectern" control in the argument's
// own header row, which is now the single deliberate way out.
//
// The post-game summary at /play/:gameId/summary is NOT this, it is a Writ
// screen and keeps the full site chrome.
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import ToastRack from './ToastRack';
import { LeaveGuardProvider } from '../../lib/leaveGuard';
import MapDialog from './MapDialog';
import TurnUpright from './TurnUpright';
import { useStageStatus } from '../../world/WorldStage';
import { roomTone } from '../../world/sfx';

export default function Chamber() {
  const { moving, mapOpen } = useStageStatus();
  // No effects bed under the argument; the room tone comes back on the way out.
  useEffect(() => { roomTone(false); return () => roomTone(true); }, []);
  return (
    // The guard has no nav links of its own here; ArgumentInner registers the browser-back handler through it, and
    // the map's plaques go through it so leaving a live argument always asks first.
    <LeaveGuardProvider>
      <main className="room-ui chamber-ui full-screen-min-h" data-moving={moving || mapOpen} aria-label="Oral argument">
        <Outlet />
      </main>
      {/* The disclaimer stays on the screen that generates the AI content it disclaims. */}
      <Footer />
      {/* Left: the right side holds the microphone and the lamps. */}
      <ToastRack placement="left" />
      <MapDialog />
      <TurnUpright />
    </LeaveGuardProvider>
  );
}
